import React from "react";
import { useRemoteComponent } from "@bookingcom/remote-component";
import Container from "../elements/Container";
import Frame from "../elements/Frame";
import useUserAgent from "../../hooks/useUserAgent";

// eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/naming-convention
const renderComponent = (Component: React.ComponentType, isMobile: boolean) => {
  return isMobile ? (
    <Frame attributes={{ style: { width: "100%" } }} p={4} mt={2} mb={2}>
      <Component />
    </Frame>
  ) : (
    <Container pt={6}>
      <Component />
    </Container>
  );
};

const GeniusSignInBanner = () => {
  const { isMobile } = useUserAgent();

  const { Component } = useRemoteComponent({
    project: "web-shell",
    service: "header-mfe",
    path: "/FlightsGeniusSignInBanner",
    type: "capla"
  });

  return renderComponent(Component, isMobile);
};

export default GeniusSignInBanner;
